import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Suspense as _Suspense, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_3 = {
  class: "p-fluid",
  style: {"min-width":"18rem"}
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = {
  key: 4,
  class: "mt-2 pt-2 text-sm white-space-pre-wrap border-1 border-100 border-left-none border-right-none border-bottom-none"
}
const _hoisted_7 = {
  key: 0,
  class: "flex align-items-center gap-2"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "flex align-items-center gap-2"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "flex gap-1" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_15 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_16 = { class: "p-fluid" }
const _hoisted_17 = { class: "p-fluid" }
const _hoisted_18 = { class: "p-fluid" }
const _hoisted_19 = { class: "p-fluid" }
const _hoisted_20 = { class: "p-fluid" }
const _hoisted_21 = { class: "p-fluid" }
const _hoisted_22 = { class: "p-fluid" }
const _hoisted_23 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueConfirmPopup = _resolveComponent("PrimeVueConfirmPopup")!
  const _component_FieldBidCPC = _resolveComponent("FieldBidCPC")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_PrimeVueOverlayPanel = _resolveComponent("PrimeVueOverlayPanel")!
  const _component_FieldFolders = _resolveComponent("FieldFolders")!
  const _component_Folders = _resolveComponent("Folders")!
  const _component_CampaignApprovalStatus = _resolveComponent("CampaignApprovalStatus")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_CampaignStatus = _resolveComponent("CampaignStatus")!
  const _component_CampaignArchivedAt = _resolveComponent("CampaignArchivedAt")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_UserColumn = _resolveComponent("UserColumn")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!
  const _component_EntriesDataTable = _resolveComponent("EntriesDataTable")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldDropdownAutoComplete = _resolveComponent("FieldDropdownAutoComplete")!
  const _component_Entries = _resolveComponent("Entries")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PrimeVueConfirmPopup),
    _createVNode(_component_PrimeVueOverlayPanel, { ref: "campaignOverlayPanel" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createBlock(_component_FieldBidCPC, {
            key: _ctx.campaignData.bid,
            modelValue: _ctx.campaignData.bid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.campaignData.bid) = $event)),
            modelModifiers: { number: true },
            name: "bid"
          }, null, 8, ["modelValue"]))
        ]),
        (_ctx.campaignData.trafficType === _ctx.TRAFFIC_TYPE_POP && _ctx.campaignData.bid > _ctx.project.max_bid_pop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('pop_bid_is_too_high')), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_PrimeVueButton, {
          label: _ctx.$t('save'),
          icon: "pi pi-save",
          loading: _ctx.campaignData.loading,
          onClick: _ctx.updateBid
        }, null, 8, ["label", "loading", "onClick"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_PrimeVueOverlayPanel, { ref: "campaignFoldersOverlayPanel" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_FieldFolders, {
            modelValue: _ctx.campaignFoldersData.folderIds,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.campaignFoldersData.folderIds) = $event)),
            label: _ctx.$t('folders'),
            inline: "",
            "allow-create": "",
            onCreated: _cache[2] || (_cache[2] = ($event: any) => (_ctx.foldersKeyCounter += 1))
          }, null, 8, ["modelValue", "label"])
        ]),
        _createVNode(_component_PrimeVueButton, {
          label: _ctx.$t('save'),
          icon: "pi pi-save",
          loading: _ctx.campaignFoldersData.loading,
          onClick: _ctx.updateCampaignFolders
        }, null, 8, ["label", "loading", "onClick"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Entries, {
      title: _ctx.$t('campaigns'),
      "href-prefix": "campaigns"
    }, {
      "buttons:append": _withCtx(({ entriesLoading }) => [
        _createVNode(_component_Folders, {
          disabled: entriesLoading,
          onDeleted: _ctx.onFolderDeleted,
          onChanged: _ctx.onFoldersChanged
        }, null, 8, ["disabled", "onDeleted", "onChanged"]),
        (_ctx.campaignsFilters.archived)
          ? _withDirectives((_openBlock(), _createBlock(_component_PrimeVueButton, {
              key: 0,
              class: "p-button-rounded p-button-outlined p-button-help ml-3 sm:ml-4",
              icon: "pi pi-trash",
              disabled: entriesLoading,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showArchived(false)))
            }, null, 8, ["disabled"])), [
              [
                _directive_tooltip,
                'Hide archived',
                void 0,
                { left: true }
              ]
            ])
          : _withDirectives((_openBlock(), _createBlock(_component_PrimeVueButton, {
              key: 1,
              class: "p-button-rounded p-button-outlined p-button-secondary opacity-30 ml-3 sm:ml-4",
              icon: "pi pi-trash",
              disabled: entriesLoading,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showArchived(true)))
            }, null, 8, ["disabled"])), [
              [
                _directive_tooltip,
                'Show archived',
                void 0,
                { left: true }
              ]
            ])
      ]),
      tables: _withCtx(() => [
        _createVNode(_component_EntriesDataTable, {
          entries: _ctx.campaigns,
          "entries-handler": _ctx.fetchCampaigns,
          "href-prefix": "campaigns"
        }, {
          actions: _withCtx(({ data, index }) => [
            (_ctx.user.isStaff())
              ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CampaignApprovalStatus, {
                      "campaign-id": data.id,
                      "campaign-approval-status": _ctx.campaigns.data[index].approval_status,
                      "onUpdate:campaignApprovalStatus": ($event: any) => ((_ctx.campaigns.data[index].approval_status) = $event)
                    }, null, 8, ["campaign-id", "campaign-approval-status", "onUpdate:campaignApprovalStatus"])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueSkeleton, {
                      width: "14px",
                      height: "14px"
                    })
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_CampaignStatus, {
                  "campaign-id": data.id,
                  "campaign-status": _ctx.campaigns.data[index].status,
                  "onUpdate:campaignStatus": ($event: any) => ((_ctx.campaigns.data[index].status) = $event)
                }, null, 8, ["campaign-id", "campaign-status", "onUpdate:campaignStatus"])
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_PrimeVueSkeleton, {
                  width: "14px",
                  height: "14px"
                })
              ]),
              _: 2
            }, 1024)),
            _createElementVNode("a", {
              href: `${_ctx.user.isStaff() ? '/statistics/staff' : '/statistics/advertiser'}?filters=${_ctx.encodeStatisticsFilters({ campaign_id: [data.id] })}`,
              target: "_blank"
            }, [
              _withDirectives(_createVNode(_component_PrimeVueButton, {
                class: "p-button-rounded p-button-text",
                icon: "pi pi-chart-bar"
              }, null, 512), [
                [
                  _directive_tooltip,
                  _ctx.$t('statistics'),
                  void 0,
                  { right: true }
                ]
              ])
            ], 8, _hoisted_4),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_CampaignArchivedAt, {
                  id: data.id,
                  "archived-at": _ctx.campaigns.data[index].archived_at,
                  "onUpdate:archivedAt": ($event: any) => ((_ctx.campaigns.data[index].archived_at) = $event)
                }, null, 8, ["id", "archived-at", "onUpdate:archivedAt"])
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_PrimeVueSkeleton, {
                  width: "14px",
                  height: "14px"
                })
              ]),
              _: 2
            }, 1024)),
            _withDirectives(_createVNode(_component_PrimeVueButton, {
              class: "p-button-rounded p-button-text p-button-secondary",
              icon: "pi pi-folder",
              onClick: ($event: any) => (_ctx.toggleCampaignFoldersOverlayPanel($event, data))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('folders'),
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives(_createVNode(_component_PrimeVueButton, {
              class: "p-button-rounded p-button-text p-button-secondary",
              icon: "pi pi-clone",
              onClick: ($event: any) => (_ctx.confirmCloneCampaign($event, data.id))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('clone'),
                void 0,
                { left: true }
              ]
            ])
          ]),
          columns: _withCtx(() => [
            _createVNode(_component_PrimeVueColumn, {
              field: "id",
              header: "ID",
              sortable: ""
            }),
            (_ctx.showProjectColumn && _ctx.user.isSuperAdmin())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 0,
                  field: "project_id",
                  header: _ctx.$t('project'),
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.project.name), 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (_ctx.showUserColumn && _ctx.user.isStaff())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 1,
                  field: "user_id",
                  header: _ctx.$t('user'),
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    (_openBlock(), _createBlock(_Suspense, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserColumn, {
                          user: data.user,
                          "show-email-as-link": ""
                        }, null, 8, ["user"])
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                      ]),
                      _: 2
                    }, 1024))
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            _createVNode(_component_PrimeVueColumn, {
              field: "name",
              header: _ctx.$t('name'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                (_ctx.user.isStaff() && data.has_violations)
                  ? _withDirectives((_openBlock(), _createBlock(_component_PrimeVueTag, {
                      key: 0,
                      class: "mr-2",
                      severity: "warning",
                      value: "🚨"
                    }, null, 512)), [
                      [_directive_tooltip, _ctx.$t('has_violations')]
                    ])
                  : _createCommentVNode("", true),
                (data.traffic_type === _ctx.TRAFFIC_TYPE_POP && data.bid > 0.10)
                  ? _withDirectives((_openBlock(), _createBlock(_component_PrimeVueTag, {
                      key: 1,
                      class: "mr-2",
                      severity: "warning",
                      value: "⚠️"
                    }, null, 512)), [
                      [_directive_tooltip, _ctx.$t('pop_bid_is_too_high')]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.user.isStaff() && data.is_builtin)
                  ? _withDirectives((_openBlock(), _createBlock(_component_PrimeVueTag, {
                      key: 2,
                      class: "mr-2",
                      value: "⚙️"
                    }, null, 512)), [
                      [_directive_tooltip, _ctx.$t('is_builtin_female')]
                    ])
                  : _createCommentVNode("", true),
                (data.max_spending && data.spent > data.max_spending)
                  ? _withDirectives((_openBlock(), _createBlock(_component_PrimeVueTag, {
                      key: 3,
                      class: "mr-2",
                      severity: "warning",
                      value: "⚠️"
                    }, null, 512)), [
                      [_directive_tooltip, _ctx.$t('max_spending_is_reached')]
                    ])
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_5, _toDisplayString(data.name), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.folders, (folder) => {
                  return (_openBlock(), _createBlock(_component_PrimeVueTag, {
                    class: "ml-2 surface-100 text-color-secondary",
                    key: folder.id,
                    value: folder.name
                  }, null, 8, ["value"]))
                }), 128)),
                (data.comment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.truncateText(data.comment, 255)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["header"]),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 2,
                  field: "adsecure_check_status",
                  header: "AdSecure",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_component_PrimeVueTag, {
                      value: _ctx.ADSECURE_CHECK_STATUSES_MAP[data.adsecure_check_status].label,
                      severity: _ctx.ADSECURE_CHECK_STATUSES_MAP[data.adsecure_check_status].severity
                    }, null, 8, ["value", "severity"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_PrimeVueColumn, {
              field: "bid",
              header: "Bid",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                (data.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPC)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$n(data.bid, 'bid')), 1),
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-xs text-500" }, "CPC", -1)),
                      _createElementVNode("i", {
                        class: "pi pi-pencil text-primary text-xs cursor-pointer",
                        onClick: ($event: any) => (_ctx.toggleCampaignOverlayPanel($event, data.id, data.bid, data.traffic_type))
                      }, null, 8, _hoisted_8)
                    ]))
                  : (data.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$n(data.bid * 1000, 'bid')), 1),
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-xs text-500" }, "CPM", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, "—"))
              ]),
              _: 1
            }),
            _createVNode(_component_PrimeVueColumn, { header: "Today spend" }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.$n(_ctx.campaigns.today_spend[data.id] || 0, 'payout')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PrimeVueColumn, {
              field: "traffic_type",
              header: _ctx.$t('type'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.TRAFFIC_TYPES_MAP[data.traffic_type].label), 1),
                  (data.creative_image_format)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "(" + _toDisplayString(_ctx.CREATIVE_IMAGE_FORMATS_MAP[data.creative_image_format]?.label) + ")", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "traffic_category",
              header: _ctx.$t('category'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.TRAFFIC_CATEGORIES_MAP[data.traffic_category].label), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "approval_status",
              header: _ctx.$t('approval_status'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _withDirectives(_createVNode(_component_PrimeVueTag, {
                  value: _ctx.$t(_ctx.CAMPAIGN_APPROVAL_STATUSES_MAP[data.approval_status].translate_key),
                  severity: _ctx.CAMPAIGN_APPROVAL_STATUSES_MAP[data.approval_status].severity
                }, null, 8, ["value", "severity"]), [
                  [_directive_tooltip, data.approval_status_comment]
                ])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "status",
              header: _ctx.$t('status'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_PrimeVueTag, {
                  value: _ctx.$t(_ctx.CAMPAIGN_STATUSES_MAP[data.status].translate_key),
                  severity: _ctx.CAMPAIGN_STATUSES_MAP[data.status].severity
                }, null, 8, ["value", "severity"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "updated_at",
              header: _ctx.$t('updated_at'),
              sortable: ""
            }, null, 8, ["header"])
          ]),
          _: 1
        }, 8, ["entries", "entries-handler"])
      ]),
      filters: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_FieldText, {
            modelValue: _ctx.campaignsFilters.id,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.campaignsFilters.id) = $event)),
            modelModifiers: { trim: true },
            label: "ID"
          }, null, 8, ["modelValue"])
        ]),
        (_ctx.showProjectColumn && _ctx.user.isSuperAdmin())
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.campaignsFilters.project_id,
                "onUpdate:modelValue": [
                  _cache[6] || (_cache[6] = ($event: any) => ((_ctx.campaignsFilters.project_id) = $event)),
                  _ctx.onProjectChange
                ],
                modelModifiers: { number: true },
                label: _ctx.$t('project'),
                loading: _ctx.projectsLoading,
                "show-clear": true,
                options: _ctx.projects.data,
                "option-value": "id",
                "option-label": "name"
              }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showUserColumn && _ctx.user.isStaff())
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_FieldDropdownAutoComplete, {
                modelValue: _ctx.campaignsFilters.user_id,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.campaignsFilters.user_id) = $event)),
                modelModifiers: { number: true },
                name: "user_id",
                label: _ctx.$t('user'),
                "show-clear": "",
                "api-url": "/api/v3/users/options",
                "api-params": _ctx.usersParams,
                "option-label": "compiled_name"
              }, null, 8, ["modelValue", "label", "api-params"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_FieldText, {
            modelValue: _ctx.campaignsFilters.name,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.campaignsFilters.name) = $event)),
            modelModifiers: { trim: true },
            label: _ctx.$t('name')
          }, null, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(), _createBlock(_component_FieldFolders, {
            key: `campaigns_filter_folder_id_${_ctx.foldersKeyCounter}`,
            modelValue: _ctx.campaignsFilters.folder_id,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.campaignsFilters.folder_id) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('folder'),
            multiple: false,
            "show-clear": ""
          }, null, 8, ["modelValue", "label"]))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.campaignsFilters.traffic_type,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.campaignsFilters.traffic_type) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('traffic_type'),
            "show-clear": true,
            options: _ctx.trafficTypes
          }, null, 8, ["modelValue", "label", "options"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.campaignsFilters.traffic_category,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.campaignsFilters.traffic_category) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('traffic_category'),
            "show-clear": true,
            options: _ctx.TRAFFIC_CATEGORIES
          }, null, 8, ["modelValue", "label", "options"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.campaignsFilters.payment_type,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.campaignsFilters.payment_type) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('payment_type'),
            "show-clear": true,
            options: _ctx.CAMPAIGN_PAYMENT_TYPES
          }, null, 8, ["modelValue", "label", "options"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.campaignsFilters.approval_status,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.campaignsFilters.approval_status) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('approval_status'),
            "show-clear": true,
            options: _ctx.CAMPAIGN_APPROVAL_STATUSES,
            "option-label-translate": ""
          }, null, 8, ["modelValue", "label", "options"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.campaignsFilters.status,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.campaignsFilters.status) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('status'),
            "show-clear": true,
            options: _ctx.CAMPAIGN_STATUSES,
            "option-label-translate": ""
          }, null, 8, ["modelValue", "label", "options"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_23, [
      _cache[21] || (_cache[21] = _createElementVNode("h5", null, "Tracking with Voluum", -1)),
      _createElementVNode("div", null, [
        _cache[18] || (_cache[18] = _createTextVNode("Voluum is our recommended tracking tool. It allows you to control all ", -1)),
        _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
        _cache[20] || (_cache[20] = _createTextVNode(" across all sources in one panel.", -1)),
        _createVNode(_component_router_link, { to: "/voluum" }, {
          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
            _createTextVNode(" See more", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ], 64))
}